module.exports = __webpack_public_path__ + "static/puppy-in-hand-cb3ac2ddd3ae87fb35aa5763d9b9673f.jpg";